import React from "react";

const RodFooter = () => {
  return (
    <div className="footer-rod-container">
      <div className="footer-rod ">
        <div>
          MADE WITH <span>💘</span> BY{" "}
          <a
            href="https://rodrigoerazo.com/"
            rel="noreferrer"
            target="_blank"
            style={{ color: "inherit" }}
          >
            RODRI.
          </a>
        </div>
      </div>
    </div>
  );
};
export default RodFooter;
